/**
 * Simple Modal Management Utilities
 * Provides basic functions for managing modal states
 *
 * Usage:
 *    openModal(modalState, setModalState, 'editModal');
 *    closeModal(modalState, setModalState, 'editModal');
 */

/**
 * Opens a specific modal
 * @param {Object} modalState - Current modal state
 * @param {Function} setModalState - State setter function
 * @param {string} modalName - Name of the modal to open
 */
export const openModal = (modalState, setModalState, modalName) => {
  setModalState({ ...modalState, [modalName]: true });
};

/**
 * Closes a specific modal
 * @param {Object} modalState - Current modal state
 * @param {Function} setModalState - State setter function
 * @param {string} modalName - Name of the modal to close
 */
export const closeModal = (modalState, setModalState, modalName) => {
  setModalState({ ...modalState, [modalName]: false });
};
